import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import { initSentry, Sentry } from "~/lib/sentry";

initSentry();

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<HydratedRouter />
		</StrictMode>,
		{
			onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
				console.error("React recovered from a rendering error", error, errorInfo.componentStack);
			}),
		},
	);
});
